/**
 * 시스템 > 모니터링 설정 > Ticket 설정 > 정책 리스트 Store
 *
 * @since 2021-06-08
 * @author wj_tams_dev04
 */
import {SystemApiPrefix as apiPrefix} from '~/utils/restApi'

export const state = () => ({
  api: `${apiPrefix}/ticket-rule-desc`,
  eventRuleList: [], // 이벤트 정책 리스트
  rsrcAlarmList: [], // 리소스 알람 리스트
  failAlarmList: [], // 장애 알람 리스트
  processAlarmList: [], // 프로세스 알람 리스트
  userDefineAlarmList: [], // 사용자 정의 로그 감시 알람 리스트
  // 이벤트 정책 리스트 조건
  payload: {
    rsrc_event_list: [277011000, 277013000, 277012010, 277012020, 277013100, 277020030],
    watch_type_list: [1, 2, 3]
  }
})

export const mutations = {
  setRuleList (state, data) {
    _.forEach(Object.keys(data), (key) => {
      if (key === 'event_rule') state.eventRuleList = data[key]
      else if (key === 'resource_alarm') state.rsrcAlarmList = data[key]
      else if (key === 'fail_alarm') state.failAlarmList = data[key]
      else if (key === 'process_watch_alarm') state.processAlarmList = data[key]
      else if (key === 'user_watch_alarm') state.userDefineAlarmList = data[key]
    })
  }
}

export const actions = {
  // 현재 범위 참조 : dispatch
  // mutation 범위 참조 : commit

  // 정책 리스트 획득
  async getRuleList ({commit, state}) {
    const payloadString = Object.entries(state.payload).map(e => e.join('=')).join('&')
    const {code, result} = await this.$axios.$get(`${state.api}/1?${payloadString}`)
    if (code && code.toLowerCase() === 'ok') {
      commit('setRuleList', result)
      return ''
    }
    return result ? result.msg : ''
  }
}

export const getters = {
}

export const strict = false
